import { INTEGRATION_TYPE } from "~/common/constants";
import { useCurrentTeamMemberContext } from "~/providers/hooks/useCurrentTeamMemberContext";
import { useListIntegrations } from "~/providers/hooks/useListIntegrations";
import { IntegrationCard } from "./IntegrationCard";

export const IntegrationCards = () => {
  const teamMember = useCurrentTeamMemberContext();
  const organization = teamMember.organization_team_members[0].organization;
  const organizationId = organization.id;
  const zoomFeatureEnabled = organization.settings?.[0]?.zoom_feature;
  const spruceFeatureEnabled = organization.settings?.[0]?.spruce_feature;
  const { data } = useListIntegrations({ organizationId });

  if (!data) return null;

  const visibleIntegrations = data.filter((integration) => {
    // TODO(APP-350): Re-enable once Zoom App is published in Marketplace.
    if (integration.type === INTEGRATION_TYPE.ZOOM_APP) {
      return false;
    }
    if (integration.type === INTEGRATION_TYPE.ZOOM) {
      return !!zoomFeatureEnabled;
    }
    if (integration.type === INTEGRATION_TYPE.SPRUCE) {
      return !!spruceFeatureEnabled;
    }
    return true;
  });

  return (
    <>
      {visibleIntegrations.map((integration) => (
        <IntegrationCard key={integration.type} integration={integration} />
      ))}
    </>
  );
};
